import { render, staticRenderFns } from "./Act_table.vue?vue&type=template&id=35eaff6e&scoped=true"
import script from "./Act_table.vue?vue&type=script&lang=js"
export * from "./Act_table.vue?vue&type=script&lang=js"
import style0 from "./Act_table.vue?vue&type=style&index=0&id=35eaff6e&prod&scoped=true&lang=css"
import style1 from "./Act_table.vue?vue&type=style&index=1&id=35eaff6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eaff6e",
  null
  
)

export default component.exports